import { axios } from "../../../lib/axios";

const reportDeliveryPayload = (props) => {
    return {
        resourceType: "ReportDelivery",
        ...props
    }
}

export const getReportDeliveries = (orgId) => {
  return axios.get(`report-delivery?${orgId ? `orgId=${orgId}`: ''}`)
}

export const createReportDelivery = (props) => {
    return axios.post(`report-delivery?orgId=${props.orgId}`, reportDeliveryPayload(props))
}

export const updateReportDelivery = (props) => {
    return axios.put(`report-delivery/${props.id}?orgId=${props.orgId}`, reportDeliveryPayload(props))
}

export const getReportDeliveryById = (id, orgId) => {
    return axios.get(`report-delivery/${id}?orgId=${orgId}`)
}

export const deleteReportDelivery = (id, orgId) => {
    return axios.delete(`report-delivery/${id}?orgId=${orgId}`)
}